import RadioGroup from './RadioGroup';
import { withFormMeta } from '../../FormMeta';
import { wrapInLabel } from '../NewInputLabelWrapper';

export default withFormMeta(wrapInLabel(RadioGroup));
